<template>
    <step-form-heading class="mt-16" :icon="faSparkles">
        Intelligent Inbox

        <template v-slot:description> Every conversation categorized, prioritized, and surfaced. </template>
    </step-form-heading>

    <motion.div
        :initial="{ opacity: 0, y: -8 }"
        :animate="{ opacity: 1, y: 0 }"
        :transition="quickTransition"
        class="sticky shrink-0 top-4 mx-auto overflow-hidden rounded-full border-solid border border-white/60 bg-slate-100/50 px-6 py-2 shadow-xl backdrop-blur-md z-20 leading-tight"
    >
        <div ref="containerRef" class="relative flex items-center gap-3 w-full max-w-md mx-auto shrink-0">
            <template v-for="(label, index) in props.stepLabels" :key="index">
                <div
                    :ref="
                        (el) => {
                            if (el) stepEls[index] = el as HTMLElement;
                        }
                    "
                    class="flex flex-col items-center gap-1"
                    :class="index === props.currentStep ? 'text-sky-600' : 'text-slate-700'"
                >
                    <span class="text-xs whitespace-nowrap hidden sm:block">{{ label }}</span>
                </div>
            </template>
            <div
                class="absolute inset-s-0 -bottom-3 block h-2 w-2 rounded-full bg-sky-600 transition-all"
                :style="{ insetInlineStart: `${ballLeft}px` }"
            ></div>
        </div>
    </motion.div>
</template>

<script lang="ts" setup>
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import { motion } from 'motion-v';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { nextTick, onMounted, ref, watch } from 'vue';
import { quickTransition } from './wizardMotionVariants';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps<{
    currentStep: number;
    stepLabels: string[];
    stepIcons: IconDefinition[];
}>();

const containerRef = ref<HTMLElement>();
const stepEls = ref<HTMLElement[]>([]);
const ballLeft = ref(0);

function updateBallPosition() {
    const container = containerRef.value;
    const step = stepEls.value[props.currentStep];
    if (!container || !step) {
        return;
    }

    const containerRect = container.getBoundingClientRect();
    const stepRect = step.getBoundingClientRect();
    const ballRadius = 4;
    ballLeft.value = stepRect.left - containerRect.left + stepRect.width / 2 - ballRadius;
}

onMounted(updateBallPosition);

watch(
    () => props.currentStep,
    () => {
        nextTick(updateBallPosition);
    }
);
</script>
